import user from '@/api/user.js'
import modelCase from '@/api/case.js'
import model from '@/api/model.js'
import material from '@/api/material.js'
import system from '@/api/system.js'
import shuyang from '@/api/shuyang.js'
import cartCase from '@/api/cartCase.js'
export default {
    user,modelCase,model , material , system , shuyang , cartCase ,
}